module.exports = __webpack_public_path__ + "img/course.d6217ffe.png";